export * from './current.os';
export * from './current.navigator';